import { render, staticRenderFns } from "./InformationAlert.vue?vue&type=template&id=1e4f7d64&scoped=true&"
import script from "./InformationAlert.vue?vue&type=script&lang=js&"
export * from "./InformationAlert.vue?vue&type=script&lang=js&"
import style0 from "./InformationAlert.vue?vue&type=style&index=0&id=1e4f7d64&prod&lang=scss&scoped=true&"
import style1 from "./InformationAlert.vue?vue&type=style&index=1&id=1e4f7d64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4f7d64",
  null
  
)

export default component.exports